import React from "react";
import _ from "lodash";
import { ToolsAPI } from "apis";
import ModalWrapper from "components/common/ModalWrapper";
import LoadingUI from "components/common/LoadingUI";
import TextArea from "components/common/TextArea";
import ClickToCopyWrapper from "components/common/ClickToCopyWrapper";

import { buttonActionClass, getMessageColorClass } from "helpers/StyleClass";
import { MESSAGE } from "constants/Message";

import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

class UnitIdExchangerModal extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      unitIds: [],
      extGamUnitIds: [],

      isLoading: false,
      msg: [],
    };

    this.handleUnitIdsChanged = this.handleUnitIdsChanged.bind(this);
    this.handleExtGamUnitIdsChanged =
      this.handleExtGamUnitIdsChanged.bind(this);
    this.handleExchangeProcess = this.handleExchangeProcess.bind(this);
  }

  handleUnitIdsChanged(value) {
    const list = this._processStringToList(value);
    this.setState({ unitIds: list });
  }

  handleExtGamUnitIdsChanged(value) {
    const list = this._processStringToList(value);
    this.setState({ extGamUnitIds: list });
  }

  async handleExchangeProcess(isGamToExt) {
    const { unitIds, extGamUnitIds } = this.state;
    this.setState({ isLoading: true, msg: [] });

    const params = {};
    const targetKey = isGamToExt ? "extGamUnitId" : "unitId";
    const sourceKey = isGamToExt ? "unitId" : "extGamUnitId";
    const sourceList = (isGamToExt ? unitIds : extGamUnitIds).filter(
      (item) => item !== ""
    );
    const filteredList = sourceList.filter((item) =>
      _.isInteger(_.toNumber(item))
    );
    params[`${sourceKey}s`] = filteredList;

    try {
      let result = [];
      if (filteredList.length > 0) {
        result = await ToolsAPI.getUnitIdsExchange(params);
      }

      if (_.isArray(result)) {
        const resultList = result.map((item) => item[sourceKey].toString());
        const targetList = result.map((item) => item[targetKey].toString());
        const lostList = _.filter(
          sourceList,
          (item) => !resultList.includes(item.toString())
        );
        this.setState({
          [`${targetKey}s`]: targetList,
          msg:
            lostList.length > 0
              ? [`Cannot be found: ${lostList.join(", ")}`, MESSAGE.WARNING]
              : [],
        });
      }
    } catch (error) {
      this.setState({
        msg: [`Failed to exchange unit ids: ${error.message}`, MESSAGE.ERROR],
      });
    } finally {
      this.setState({ isLoading: false });
    }
  }

  _processStringToList(value) {
    return value === "" ? [] : value.split(",").map((item) => item.trim());
  }

  render() {
    const { isLoading, unitIds, extGamUnitIds, msg } = this.state;
    const { onClose } = this.props;

    return (
      <ModalWrapper
        isOpen={true}
        showCloseFooter={true}
        customOverlayStyle={{ zIndex: 100 }}
        handleClose={onClose}
        title="Unit Ids Exchanger"
      >
        {isLoading && (
          <div
            className="absolute left-0 top-0 z-20 flex h-full w-full items-center justify-center"
            style={{ backgroundColor: "rgba(255, 255, 255, 0.8)" }}
          >
            <LoadingUI iconOnly={true}></LoadingUI>
          </div>
        )}
        <div className="mb-2 flex gap-2">
          <div className="flex-1">
            <div className="mb-1 flex items-end justify-between">
              <label className="text-sm font-semibold text-gray-600">
                Unit IDs
              </label>
              <ClickToCopyWrapper
                place="left"
                copyText={unitIds.join(",")}
                tooltipMessage="Click to copy Unit IDs"
              ></ClickToCopyWrapper>
            </div>
            <TextArea
              inputValue={unitIds.join(",")}
              handleChange={this.handleUnitIdsChanged}
              rows={8}
            />
          </div>
          <div className="ml-1 flex w-10 flex-col items-center justify-center pt-8">
            <button
              type="button"
              className={`flex w-full items-center justify-center ${buttonActionClass}`}
              onClick={() => this.handleExchangeProcess(true)}
            >
              <FaArrowRight />
            </button>
            <button
              type="button"
              className={`flex w-full items-center justify-center ${buttonActionClass}`}
              onClick={() => this.handleExchangeProcess(false)}
            >
              <FaArrowLeft />
            </button>
          </div>
          <div className="flex-1">
            <div className="mb-1 flex items-end justify-between">
              <label className="text-sm font-semibold text-gray-600">
                Ext. Unit IDs
              </label>
              <ClickToCopyWrapper
                place="left"
                copyText={extGamUnitIds.join(",")}
                tooltipMessage="Click to copy Ext. Unit IDs"
              ></ClickToCopyWrapper>
            </div>
            <TextArea
              inputValue={extGamUnitIds.join(",")}
              handleChange={this.handleExtGamUnitIdsChanged}
              rows={8}
            />
          </div>
        </div>
        <div
          className={`rounded mb-2 overflow-y-auto overflow-x-hidden break-all px-4 py-2 text-lg font-semibold ${
            msg.length > 1 ? getMessageColorClass(msg[1]) : ""
          }`}
          style={{ maxHeight: "100px" }}
        >
          {msg.length > 0 ? msg[0] : ""}
        </div>
      </ModalWrapper>
    );
  }
}

export default UnitIdExchangerModal;
